import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import { THEME } from '../../genericComponents/globalStyles';
import AdvanceFilter from './AdvanceFilter';
import { speakersNum } from '../../../helpers/heatMap';
import HorizontalSelector from '../../genericComponents/HorizontalSelector';
import { PrymaryButton } from '../../genericComponents/Button';
import { Select, Tooltip } from 'antd';
import ShadowCard from '../../genericComponents/ShadowCard';
import { CloseOutlined, FilterOutlined, PlusOutlined } from '@ant-design/icons';
import Text from '../../genericComponents/Text';
import { RowTypeSpaceBetween } from '../../genericComponents/Layouts';
import {useTranslation} from 'react-i18next'; 
import AdvanceFilterModal from './AdvanceFilterModal';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function GeneralFilters({
  setSimulationLoading,
  speakerFilteredList,
  setAdvancedFilters,
  setSimulationType,
  setFrecuencyRange,
  setSimulationData,
  advancedFilters,
  simulationType,
  availablePower,
  frecuencyRange,
  setNoiseLevel,
  setEarHeight,
  setTypePower,
  setSpeaker,
  noiseLevel,
  earHeight,
  typePower,
  setHeigth,
  setWidth,
  setPower,
  speaker,
  setLong,
  heigth,
  power,
  width,
  long,
}){
  const { t } = useTranslation();
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false);
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  async function onSimulation() {
    try {
      setSimulationData(null)
      let newearHeight=earHeight;
      let newnoiseLevel=noiseLevel;
      let newspeaker=speakerFilteredList?.find(sp=>sp.idProduct===speaker);
      if(!newspeaker)return alert("speaker es requerido");
      if(!power)return alert("power speaker es requerido");
      if(!width)return alert("Largo es requerido");
      if(!heigth)return alert("ancho es requerido");
      if(!long)return alert("alto es requerido");
      if(!newearHeight)newearHeight=1.7;
      if(!newnoiseLevel)newnoiseLevel=50;
      setSimulationLoading(true);
      const splMax = Number(newspeaker.sensitivity)+10*Math.log10(Number(power));
      const alpha = Number(newspeaker[frecuencyRange]);
      setTimeout(async () => {
        const simulation = await speakersNum(
          Number(width),
          Number(heigth),
          Number(long),
          Number(newearHeight),
          alpha,
          splMax,
          Number(newnoiseLevel),
          simulationType,
          frecuencyRange
        );
        if(simulation){
          setSimulationData({
            ...simulation,
            speaker:newspeaker,
            power,
            typePower,
            width,
            heigth,
            long,
            newearHeight,
            newnoiseLevel,
            simulationType,
            frecuencyRange
          });
        }
        setSimulationLoading(false);
      }, 100);
    } catch (error) {
      setSimulationLoading(false);
      console.log(error)
      if(error.message==="Los datos introducidos son erroneos") return alert(error.message);
    }
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <LeftSidebar>
      <div>
        <Text titleSize={2}>{t('enter_your_variables')}</Text>
        <RoomCard>
          <Text titleSize={2} titleLevel={1}>{t('room')}</Text>
          <RowTypeSpaceBetween>
            <ContSisez>
              <Text titleSize={1} titleLevel={1} >{t('length_m')}</Text>
              <Tooltip title={t('length_in_meters_x_coordinate')} color={THEME.colors.blue}>
                <Input value={width} style={{marginTop:2}} onChange={e=>setWidth(e.target.value)} placeholder={t('enter')} type="number" />
              </Tooltip>
            </ContSisez>
            <div style={{width:8}}/>
            <ContSisez>
              <Text titleSize={1} titleLevel={1}>{t('width_m')}</Text>
              <Tooltip title={t('width_in_meters_y_coordinate')} color={THEME.colors.blue}>
                <Input value={heigth} style={{marginTop:2}} onChange={e=>setHeigth(e.target.value)} placeholder={t('enter')} type="number" />
              </Tooltip>
            </ContSisez>
            <div style={{width:8}}/>
            <ContSisez>
              <Text titleSize={1} titleLevel={1}>{t('height_m')}</Text>
              <Tooltip title={t('height_in_meters_z_coordinate')} color={THEME.colors.blue}>
                <Input value={long} style={{marginTop:2}} onChange={e=>setLong(e.target.value)} placeholder={t('enter')} type="number" />
              </Tooltip>
            </ContSisez>
          </RowTypeSpaceBetween>
        </RoomCard>
      </div>
      <SpeakerCard>
        <Text titleSize={2} titleLevel={1}>{t('speaker_selection')}</Text>
        <SpeakerOrientationCard>
          <ResponsiveVerticalContainer style={{minWidth:200}}>
            <Text titleSize={1} titleLevel={1}>{t('kind_of_power')}</Text>
            <HorizontalSelector
              options={[{value:'100V',text:'100V'},{value:'70V',text:'70V'},{value:'lowImpedance',text:t('low_impedance'),minWidth:'80px'}]}
              selected={typePower}
              childStyle={{padding:'0px 20px'}}
              onChange={(o)=>setTypePower(o.value)}
            />
          </ResponsiveVerticalContainer>
          <ResponsiveVerticalContainer style={{minWidth:120}}>
            <Text titleSize={1} titleLevel={1}>{t('select_speaker')}</Text>
            <CustomSelect 
              style={{color:THEME.colors.darkBlue, width:'100%',marginTop:'4px' }} 
              onChange={setSpeaker}
              value={speaker}
              placeholder={t('speaker_models')}
            >
              {speakerFilteredList?.map(sf=>
                <Select.Option key={sf.idProduct} value={sf.idProduct}>
                  {sf.speakerName}
                </Select.Option>
              )}
            </CustomSelect>
            <AdvanceFilteringCont>
              <div/>
              <FilteringButton onClick={()=>setShowAdvanceFilter(saf=>!saf)}>
                <FilterOutlined style={{color:THEME.colors.blue, fontSize: 16}} />
                {` ${t('filgter_speakers')} `}
                {showAdvanceFilter?
                  <CloseOutlined style={{color:THEME.colors.blue, fontSize: 16}}/>
                :
                  <PlusOutlined style={{color:THEME.colors.blue, fontSize: 16}} />
                }
              </FilteringButton>
            </AdvanceFilteringCont>

            {windowDimensions.width<=1337?
              <AdvanceFilterModal
                isVisible={showAdvanceFilter}
                setVisible={setShowAdvanceFilter}
                speakerFilteredList={speakerFilteredList}
                advancedFilters={advancedFilters}
                setAdvancedFilters={(key,value)=>
                  setAdvancedFilters({...advancedFilters,[key]:value})
                }
              />
            :
              showAdvanceFilter&&(
                <>
                  <Text titleSize={2} titleLevel={1}>{t('advanced_filters')}</Text>
                  <AdvanceFilter
                    speakerFilteredList={speakerFilteredList}
                    advancedFilters={advancedFilters}
                    setAdvancedFilters={(key,value)=>
                      setAdvancedFilters({...advancedFilters,[key]:value})
                    }
                  />
                </>
              )
            }
          </ResponsiveVerticalContainer>

          {/* <br/> */}
          <ResponsiveVerticalContainer style={{minWidth:150}}>
            <Text titleSize={1} titleLevel={1}>{t('available_powers')}</Text>
            <CustomSelect 
              style={{color:THEME.colors.darkBlue, width:'100%',marginTop:'4px' }} 
              onChange={setPower}
              value={power}
              placeholder={t('select_power')}
            >
              {availablePower?.map(ap=>
                <Select.Option key={ap[typePower]} value={ap[typePower]}>
                  {ap[typePower]}W
                </Select.Option>
              )}
            </CustomSelect>
          </ResponsiveVerticalContainer>
        </SpeakerOrientationCard>
      </SpeakerCard>
      <SimulationParametersCard style={{width:'unset'}}>
        <Text titleSize={2} titleLevel={1}>{t('simulation_parameters')}</Text>
        <SimulationParametersResponsive>
          <SimulationTypeCont>
            <Text titleSize={1} titleLevel={1}>{t('simulation_type')}</Text>
            <HorizontalSelector
              options={[
                {value:1,text:t('edge_to_edge'),tooltip:t('edge_to_edge_tootlip_text')},
                {value:2,text:t('minimum_overlap'),tooltip:t('minimum_overlap_tooltip_text')},
                {value:3,text:t('center_to_center'),tooltip:t('center_to_center_tooltip_text')}
              ]}
              childStyle={{padding:'0px 12px'}}
              selected={simulationType}
              style={{minWidth:270}}
              onChange={(o)=>setSimulationType(o.value)}
            />
          </SimulationTypeCont>
          <FrequencyRangeCont>
            <Text titleSize={1} titleLevel={1}>{t('frequency_range')}</Text>
            <HorizontalSelector
              options={[
                {value:'polars2500Hz',text:t('public_address_2500Hz'),tooltip:t('Public_Address_2500Hz_tooltip_text'),minWidth:130},
                {value:'polars5000Hz',text:t('voice_5000Hz'),tooltip:t('voice_5000Hz_tooltip_text')},
                {value:'polars10000Hz',text:t('music_10000Hz'),tooltip:t('music_10000Hz_tooltip_text')}
              ]}
              childStyle={{padding:'0px 16px'}}
              selected={frecuencyRange}
              onChange={(o)=>setFrecuencyRange(o.value)}
            />
          </FrequencyRangeCont>
          <InputsCont>
            <div style={{minWidth:155}}>
              <Text titleSize={1} titleLevel={1}>{t('background_noise_dB')}</Text>
              <Tooltip title={t('background_noise_level_tooltip')} color={THEME.colors.blue}>
                <Input 
                value={noiseLevel} 
                onChange={e=>setNoiseLevel(e.target.value)} 
                normalPlaceholder
                placeholder={`50 (${t('default')})`} 
                type="number" />
              </Tooltip>
            </div>
            <div style={{width:8}}/>
            <div>
              <Text titleSize={1} titleLevel={1}>{t('ear_height_m')}</Text>
              <Tooltip title={t('location_of_the_audience_tooltip')} color={THEME.colors.blue}>
                <Input 
                  value={earHeight} 
                  onChange={e=>setEarHeight(e.target.value)} 
                  normalPlaceholder 
                  placeholder={`1.7 (${t('default')})`} 
                  type="number" 
                />
              </Tooltip>
            </div>

          </InputsCont>
        </SimulationParametersResponsive>
      </SimulationParametersCard>
      <SimulationButton onClick={onSimulation}>{t('simulate')}</SimulationButton>
    </LeftSidebar>
  )
}

const LeftSidebar = styled.div`
  width: 350px;
  min-width: 300px;
  z-index: 1;
  background-color: #FFF;
  display: flex;
  flex-direction: column;
  @media (max-width: 1337px) {
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;
  }
  @media (max-width: 967px) {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
`;
const ContSisez = styled.div`
  display: flex;
  flex:1;
  flex-direction: column;
`;
const Input = styled.input`
  width: 100%;
  ::placeholder {
    color: ${p=>p.normalPlaceholder?THEME.colors.darkBlue:THEME.colors.darkBlue+88};
    font-style: ${p=>p.normalPlaceholder?'normal':'italic'};
  }
  :focus{
    border:  2px solid ${THEME.colors.blue}55 ;
  }
`;
const FilteringButton = styled.button`
  color: ${THEME.colors.blue};
  font-size: 0.9em;
  text-decoration: underline;
  background: none;
  border: none;
  padding: 8px 0;
  height: 25px;
`;
const CustomSelect = styled(Select)`
  width: 100%;
  color:${THEME.colors.darkBlue};
  span{
    color:${THEME.colors.darkBlue};
  }
`;
const RoomCard = styled(ShadowCard)`
  max-width: 350px;
  height: 140px;
  padding-top: 8px;
  @media (max-width: 1337px) {
    margin-right: 16px;
  }
`;
const SpeakerCard = styled(ShadowCard)`
  display:flex;
  flex-direction: column;
  @media (max-width: 1337px) {
    flex:1;
    height: 140px;
  }
`;
const SpeakerOrientationCard = styled.div`
  @media (max-width: 1337px) {
    display: flex;
  }
`;
const AdvanceFilteringCont = styled(RowTypeSpaceBetween)`
  padding-bottom: 8px;
  @media (max-width: 1337px) {
    /* margin-top: -12px; */
  }
`;
const ResponsiveVerticalContainer=styled.div`
  display:flex;
  flex:1;
  flex-direction:column;
  margin:0 4px;
`;
const SimulationButton = styled(PrymaryButton)`
  @media (max-width: 1337px) {
    max-width: 300px;
    align-self: center;
    margin-left: 4px;
    flex:1;
  }
`;
const SimulationTypeCont = styled(ResponsiveVerticalContainer)`
  @media (max-width: 1337px) {
    max-width: 270px;
  }
`;
const FrequencyRangeCont=styled(ResponsiveVerticalContainer)`
  @media (max-width: 1337px) {
    max-width: 300px;
  }
`;
const SimulationParametersCard = styled(ShadowCard)`
  display:flex;
  flex-direction: column;
  @media (max-width: 1337px) {
    flex:1;
    height: 140px;
  }
  @media (max-width: 967px) {
    height: fit-content;
  }
`;

const InputsCont=styled(RowTypeSpaceBetween)`
  min-width: 280px;
`;

const SimulationParametersResponsive = styled.div`
  @media (max-width: 1337px) {
    display: flex;
  }
  @media (max-width: 905px) {
    flex-wrap: wrap;
  }
`;